/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Images
import bgImage from "assets/images/cta-bg.png";

function Download() {
  return (
    <MKBox component="section" py={{ xs: 8, sm: 12 }}>
      <MKBox
        variant="gradient"
        bgColor="dark"
        position="relative"
        borderRadius="xl"
        sx={{ overflow: "hidden" }}
      >
        <MKBox
          component="img"
          src={bgImage}
          alt="pattern-lines"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          zIndex={1}
          opacity={0.4}
          sx={{ objectFit: "cover" }}
        />
        <Container sx={{ position: "relative", zIndex: 2, py: 10 }}>
          <Grid container item xs={12} md={8} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography variant="h2" color="white" fontWeight="bold" mb={2}>
              Partner with Alpha Group
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mb={6} px={{ xs: 2, lg: 6 }}>
              {`Partner with Alpha Group for your next architectural masterpiece in Azerbaijan or Mauritius. Our experts in Baku and Port Louis are ready to deliver excellence in construction and real estate.`}
            </MKTypography>
            <MKButton
              variant="contained"
              size="large"
              component="a"
              href="mailto:info@alphagrouplimited.com"
              sx={{
                backgroundColor: "#AA8453",
                color: ({ palette: { white } }) => white.main,
                fontSize: "1rem",
                fontWeight: "bold",
                padding: "12px 32px",
                "&:hover": {
                  backgroundColor: "#8e6d42",
                },
              }}
            >
              START YOUR PROJECT
            </MKButton>
          </Grid>
        </Container>
      </MKBox>
      <Container>
        <Grid container item xs={12} mx="auto">
          <MKBox textAlign="center" width="100%">
            <MKTypography variant="h3" mt={6} mb={3}>
              Strategic Market Presence
            </MKTypography>
            <Grid container spacing={3} justifyContent="center">
              {["Baku, Azerbaijan", "Ebene, Mauritius"].map((region) => (
                <Grid item xs={12} md={4} key={region}>
                  <MKBox
                    p={3}
                    textAlign="center"
                    sx={{
                      border: "1px solid #AA8453",
                      borderRadius: "15px",
                      backgroundColor: "#fafafa",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "#AA8453",
                        "& .region-text": { color: "#fff" },
                      },
                    }}
                  >
                    <MKTypography
                      variant="button"
                      fontWeight="bold"
                      textTransform="uppercase"
                      className="region-text"
                    >
                      {region}
                    </MKTypography>
                  </MKBox>
                </Grid>
              ))}
            </Grid>
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Download;
